import { render, staticRenderFns } from "./InspectionReport.vue?vue&type=template&id=36cbe672&scoped=true"
import script from "./InspectionReport.vue?vue&type=script&lang=js"
export * from "./InspectionReport.vue?vue&type=script&lang=js"
import style0 from "./InspectionReport.vue?vue&type=style&index=0&id=36cbe672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbe672",
  null
  
)

export default component.exports